import {ExternalLink, styled, Text} from "@reside/ui";

export const CopyrightFooter = styled.footer`
  position: fixed;
  inset-inline: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline-start: ${({theme}: any) => theme.space[4]}px;
  padding-block: ${({theme}: any) => theme.space[1] * 0.5}px;
  pointer-events: none;
  user-select: none;
  background-color: ${({theme}: any) => theme.color.darkBlue5};
`;

export const CopyrightInfo = styled(Text)`
  font-size: 0.675rem;
`;

export const CopyrightLink = styled(ExternalLink)`
  text-decoration: none;
  pointer-events: all;
`;
